import WidgetType from "../../../core/constants/widgetType.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator";

const getDefaultWidgetLegend = (widgetType, payload) => {
  let newLegendId = payload.newLegendId;

  switch(widgetType) {
    case WidgetType.SPREADSHEET: {
      const spreadsheetLegend = {
        id: "spreadsheet",
        expressions: {
          y: ""
        },
        mappings: {},
        parameters: {
          legendLabel: ""
        },
        cells: [],
        errors: {}
      };
      const defaultSize = 4;
      for (let i = 0; i < defaultSize; i++) {
        for (let j = 0; j < defaultSize; j++) {
          spreadsheetLegend.cells.push({
            row: i,
            col: j,
            expressions: {
              y: ""
            }
          });
        }
      }
      return spreadsheetLegend;
    }
    case WidgetType.TRADING_VIEW: {
      // trading view requires string id
      newLegendId = UniqueIdGenerator.id();
    }
    default: {
      let key = UniqueIdGenerator.id();
      let expression = key;
      let label = "";

      if (payload.dataset == null) {
        expression = payload.name;
        label = payload.name.replace("()", "");
      } else {
        label = payload.dataset.name + " " + payload.field.name;
      }

      const legend = {
        id: newLegendId,
        expressions: {
          y: expression
        },
        mappings: {},
        parameters: {
          groupId: newLegendId,
          legendLabel: label,
          legendColor: payload.newLegendColor,
          isActive: true,
          chartTypeParameters: {
            fillOpacity: 1,
            strokeOpacity: 1
          }
        },
        errors: {}
      };

      if (payload.dataset != null) {
        legend.mappings[key] = {
          datasetId: payload.dataset.persistenceId,
          fieldId: payload.field.fieldId,
          value: payload.dataset.name.replace(/([\+\-\*\/])/g, "_") + " " + payload.field.name
        };
      }
      switch (widgetType) {
        case WidgetType.TIME_SERIES: {
          legend.parameters.chartType = "line";
          legend.parameters.yAxisSide = "left";
          break;
        }
        case WidgetType.TIME_SERIES_VERTICAL: {
          legend.parameters.chartType = "line";
          legend.parameters.yAxisSide = "right";
          break;
        }
        case WidgetType.GAUGE: {
          legend.parameters.chartTypeParameters.min = 0;
          legend.parameters.chartTypeParameters.max = 1;
          break;
        }
        case WidgetType.TABLE: {
          for (let i = 0; i < payload.dataProfile.fields.length; i++) {
            payload.dataProfile.fields[i].activated = true;
          }
          legend.parameters.columns = payload.dataProfile.fields;
          break;
        }
        case WidgetType.TRADING_VIEW: {
          legend.parameters.pane = 0;
          break;
        }
      }

      return legend;
    }
  }
};

const getDefaultPreviewWidgetLegend = (widgetType, props) => {
  let defaultLegend = {
    id: 1,
    expressions: {
      y: "exp"
    },
    mappings: {
      exp: {
        datasetId: props.dataset.datasetId,
        fieldId: props.field.fieldId,
        value: props.field.name
      }
    },
    parameters: {
      groupId: 1,
      legendLabel: props.field.name,
      legendColor: "#1f77b4",
      isActive: true,
      chartTypeParameters: {}
    },
    errors: {}
  };

  switch (widgetType) {
    case WidgetType.TIME_SERIES:
      defaultLegend.parameters.chartTypeParameters = {
        fillOpacity: 1,
        strokeOpacity: 1
      };
      defaultLegend.parameters.chartType = "line";
      defaultLegend.parameters.yAxisSide = "left";
      break;
    case WidgetType.GAUGE:
      defaultLegend.parameters.chartTypeParameters = {
        min: 0,
        max: 1
      };
      break;
    case WidgetType.TABLE:
      defaultLegend.parameters["columns"] = props.fields.map(function (field) {
        field["activated"] = true;
        return field;
      });
      break;
    case WidgetType.TEXTUAL:
      defaultLegend.parameters.chartTypeParameters.type = "String";
  }

  return defaultLegend;
};

export {getDefaultWidgetLegend, getDefaultPreviewWidgetLegend};


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/defaultLegend.js